/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningCircleIcon20Regular = forwardRef('WarningCircleIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M10.75 6.688a.75.75 0 0 0-1.5 0v3.565a.75.75 0 1 0 1.5 0V6.687Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.001 10A7.999 7.999 0 1 1 18 10 7.999 7.999 0 0 1 2 10Zm8-6.499A6.499 6.499 0 1 0 10 16.5 6.499 6.499 0 0 0 10 3.5Z" })));
});
